module.exports = __webpack_public_path__ + "static/mobby-effect-0a4a1a3f217779f5406406dd135038dc.svg";